import { createWidget } from '@alfa-bank/site-util-create-widget';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import { OneFieldFioDesktop as OneFieldFioInput } from '@alfa-bank/site-one-field-fio/desktop';
import { RadioTagsController } from '@alfa-bank/site-one-field-fio/radio-tags-controller';
import { Fields } from '@alfa-bank/site-form-utils/components/multi-field';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { FormInput as Input } from '@alfa-bank/site-form-input';
import { FioField } from '@alfa-bank/site-form-fio/fio-field';
import { AnalyticsEventSender } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender';

import type { TFio, IDeps } from '../models';
import { OneFieldFio as Component } from '../one-field-fio';

import styles from './one-field-fio-desktop.css';
import { fioWrapperClassNameHelperDesktop } from './helpers';

export const OneFieldFioDesktop = createWidget<IDeps, TFio>({
    AnalyticsEventSender,
    Input,
    Field,
    Fields,
    FioField,
    OneFieldFioInput,
    RadioTagsController,
    validateNotEmpty,
    styles,
    fioWrapperClassNameHelper: fioWrapperClassNameHelperDesktop,
})(Component);
